module.exports = __webpack_public_path__ + "static/img/icon-common-review-sucess.573ab09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/common/icon-common-review-sucess.png
// module id = Im7r
// module chunks = 1